import { createEntityAdapter } from "@ngrx/entity";
import { createAction, createReducer, createSelector, on } from "@ngrx/store";
import { RootSelectors } from "../app.selectors";
import { Guid } from 'shared/models/guid';
export var BargainingUnitProfileEntity;
(function (BargainingUnitProfileEntity) {
    var _a;
    BargainingUnitProfileEntity.updateMany = createAction('[BargainingUnitProfileEntity] - Update Many', function (items) { return ({ items: items }); });
    BargainingUnitProfileEntity.updateOne = createAction('[BargainingUnitProfileEntity] - Update One', function (item) { return ({ item: item }); });
    BargainingUnitProfileEntity.removeAll = createAction('[BargainingUnitProfileEntity] - Remove All');
    var adapter = createEntityAdapter({
        selectId: function (item) { return item.id; }
    });
    var initialState = adapter.getInitialState();
    var entityReducer = createReducer(initialState, on(BargainingUnitProfileEntity.updateMany, function (state, _a) {
        var items = _a.items;
        return adapter.upsertMany(items, state);
    }), on(BargainingUnitProfileEntity.updateOne, function (state, _a) {
        var item = _a.item;
        return adapter.upsertOne(item, state);
    }), on(BargainingUnitProfileEntity.removeAll, function (state) { return adapter.removeAll(state); }));
    function reducer(state, action) {
        if (state === void 0) { state = initialState; }
        return entityReducer(state, action);
    }
    BargainingUnitProfileEntity.reducer = reducer;
    _a = adapter.getSelectors(RootSelectors.getProfilesEntitiyState), BargainingUnitProfileEntity.selectAll = _a.selectAll, BargainingUnitProfileEntity.selectEntities = _a.selectEntities;
    BargainingUnitProfileEntity.currentProfile = createSelector(RootSelectors.getProfileId, BargainingUnitProfileEntity.selectEntities, function (getProfileId, entities) {
        var profile = undefined;
        if (getProfileId === undefined) {
            profile = {
                id: Guid.empty
            };
        }
        else {
            profile = entities !== undefined ? entities[getProfileId] : undefined;
        }
        return profile;
    });
    //export function normailizeProfile(payload: BUProfile): { profile: BUProfile, environmentConfigurations: EnvironmentConfiguration[] } {
    //  const environmentsSchema = new schema.Entity('environments', {}, {
    //    idAttribute: (value: EnvironmentConfiguration) => `${value.id}`
    //  });
    //  const appScehama = new schema.Entity('applications', {
    //    environments: [environmentsSchema]
    //  });
    //  const data: {
    //    entities: {
    //      applications: { [id: string]: Application },
    //      environments: { [id: string]: EnvironmentConfiguration }
    //    }
    //  } = normalize(payload, appScehama);
    //  const apps = data.entities.applications ? Object.values(data.entities.applications) : [];
    //  const environmentConfigurations = data.entities.environments ? Object.values(data.entities.environments) : [];
    //  return { application: apps.length > 0 ? apps[0] : undefined, environmentConfigurations: environmentConfigurations }
    //}
})(BargainingUnitProfileEntity || (BargainingUnitProfileEntity = {}));
